import React, { useState } from "react";
import "./wizardStyle.scss";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import StepThree from "./stepThree";

const Wizard = ({ stepNo, totalStep, failedStep }) => {
  const [step, setStep] = useState(stepNo);

  const nextStep = () => {
    if (step < totalStep) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <StepOne />;
      case 2:
        return <StepTwo />;
      case 3:
        return <StepThree />;
      default:
        return <div>Step {step}</div>; // fallback for more steps
    }
  };

  return (
    <div className="wizard">
      {/* Dynamic Step Indicators */}
      <div className="wizard-steps">
        {[...Array(totalStep)].map((_, index) => {
          let className = "step";
          const stepIndex = index + 1;

          if (stepIndex === failedStep) {
            className += " failed";
          } else if (step > stepIndex) {
            className += " completed";
          } else if (step === stepIndex && step === totalStep) {
            className += " completed"; // ✅ last step - show as completed
          } else if (step === stepIndex) {
            className += " active";
          }

          return (
            <div key={index} className={className}>
              {step <= stepIndex ? stepIndex : ""}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Wizard;
